module.exports = __webpack_public_path__ + "static/img/shangjia3.8efc3c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/shangjia3.jpg
// module id = 1422
// module chunks = 1